import React, { useEffect } from "react";
import "../../Assets/Styles/pages/landing.scss";
import Banner from "../../Components/FAQComponents/banner";
import Questions from "../../Components/FAQComponents/questions";
import ContactUs from "../../Components/ContactUs/ContactUs";
import { useState } from "react";

const FAQ = () => {
    const [searchString, setSearhString] = useState("")
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Banner searchString={searchString} setSearhString={setSearhString} />
            <Questions searchString={searchString} setSearhString={setSearhString} property={"faq"} />
            <ContactUs />
        </>
    )

}

export default FAQ;
